<!--
  --
  -- 時間切れダイアログ コンポーネント
  --
  -- timeLimit に指定された日時を過ぎると、時間切れを示すダイアログを
  -- 表示する。このダイアログは閉じることができず、`最初からやり直す`
  -- ボタンで任意のページに遷移する仕組みを提供する。
  --
  -- timeLimit プロパティは unix epoch の数値で指定する。
  -- `最初からやり直す` ボタンを押すと、`rewind` イベントを送出する。
  --
  -->
<template>
  <v-dialog
    v-model="show"
    persistent
    :max-width="$vuetify.breakpoint.xsOnly ? 288 : 480"
    overlay-color="black"
    overlay-opacity=".95"
  >
    <v-card>
      <v-card-title>時間切れ</v-card-title>
      <v-card-text>
        <slot />
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          color="primary"
          :loading="running"
          :disabled="running"
          @click="onRewind"
        >
          最初からやり直す
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'CTimeoutDialog',
  props: {
    timeLimit: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    show: false,
    timerID: 0,

    // 処理中
    running: false
  }),
  created () {
    this.timerID = setInterval(() => {
      const now = Date.now()

      if (this.timeLimit < now) {
        clearInterval(this.timerID)
        this.timerID = 0
        this.show = true
      }
    }, 1000)
  },
  destroyed () {
    if (this.timerID !== 0) {
      clearInterval(this.timerID)
      this.timerID = 0
    }
  },
  methods: {
    /**
     * 最初からやり直すボタンが押された
     */
    onRewind () {
      this.show = false
      this.running = true
      this.$emit('rewind', () => {
        this.running = false
      })
    }
  }
}
</script>
